import React from 'react';
import { Box, Typography } from '@mui/material';

const Logo = ({ showText = false, variant = "default", size = "medium" }) => {
  const sizeMap = {
    small: { width: 48, height: 48, fontSize: '0.875rem' },
    medium: { width: 64, height: 64, fontSize: '1.125rem' },
    large: { width: 80, height: 80, fontSize: '1.375rem' }
  };

  const currentSize = sizeMap[size] || sizeMap.medium;

  // Create a logo that uses the actual Call Ninja logo
  const renderLogo = () => {
    if (variant === "icon-only") {
      return (
        <Box
          sx={{
            width: currentSize.width,
            height: currentSize.height,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f8fafc', // Light gray background that matches page theme
            borderRadius: '8px', // Rounded corners
            padding: '4px' // Small padding
          }}
        >
          <img
            src="https://www.callninja.ai/logo.png"
            alt=""
            style={{
              width: `${currentSize.width}px`,
              height: `${currentSize.height}px`,
              objectFit: 'contain',
              filter: variant === 'light' ? 'brightness(0) invert(1)' : 
                     variant === 'dark' ? 'brightness(0)' : 'none'
            }}
          />
        </Box>
      );
    }

    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {/* Logo Image */}
        <Box
          sx={{
            width: currentSize.width,
            height: currentSize.height,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f8fafc', // Light gray background that matches page theme
            borderRadius: '8px', // Rounded corners
            padding: '4px' // Small padding
          }}
        >
          <img
            src="https://www.callninja.ai/logob.png"
            alt=""
            style={{
              width: `${currentSize.width}px`,
              height: `${currentSize.height}px`,
              objectFit: 'contain',
              filter: variant === 'light' ? 'brightness(0) invert(1)' : 
                     variant === 'dark' ? 'brightness(0)' : 'none'
            }}
          />
        </Box>

        {/* Text - Only show if showText is true and we want to show additional text */}
        {showText && (
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                color: '#000000', // Black text
                lineHeight: 1,
                fontSize: currentSize.fontSize
              }}
            >
              Call
            </Typography>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                color: '#000000', // Black text
                lineHeight: 1,
                fontSize: currentSize.fontSize
              }}
            >
              Ninja
            </Typography>
          </Box>
        )}
      </Box>
    );
  };

  return renderLogo();
};

export default Logo; 